export default __webpack_public_path__ + "static/media/Q1-1.3e3162a7.jpg";